import {NatGetMenuMaster} from './NatGetMenuMaster';
import {NatGetMenuMasterAuthedResident} from './NatGetMenuMasterAuthedResident'
import Http from '../../../../network/Http'
import {NatGetMenuMasterAuthedAdmin} from './NatGetMenuMasterAuthedAdmin';

export default class NatMenuMasterRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // メニューマスタ一覧取得
    async getMenuMaster(): Promise<NatGetMenuMaster> {
        return await this.http.get(`/api/admin/menuMaster`);
    }

    // メニューマスタ一覧取得（ログイン済：居住者）
    async getMenuMasterAuthedResident(): Promise<NatGetMenuMasterAuthedResident> {
        return await this.http.get(`/api/resident/menuMaster/authed`);
    }

    // メニューマスタ一覧取得（ログイン済：管理）
    async getMenuMasterAuthedAdmin(): Promise<NatGetMenuMasterAuthedAdmin> {
        return await this.http.get(`/api/admin/menuMaster/authed`);
    }
}
